import { NxButtonModule } from '@allianz/ng-aquila/button';
import { NxLinkModule } from '@allianz/ng-aquila/link';
import { NxModalModule } from '@allianz/ng-aquila/modal';
import { NxCopytextModule } from '@allianz/ng-aquila/copytext';
import { NxHeadlineModule } from '@allianz/ng-aquila/headline';

import { NxIconModule } from '@allianz/ng-aquila/icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NxGridModule } from '@allianz/ng-aquila/grid';
import { ConfirmationModalComponent } from './confirmation-modal.component';

@NgModule({
  imports: [
    NxButtonModule,
    NxIconModule,
    NxLinkModule,
    NxModalModule,
    NxGridModule,
    NxCopytextModule,
    NxHeadlineModule,
    CommonModule,
    ConfirmationModalComponent,
  ],
  exports: [ConfirmationModalComponent],
})
export class ConfirmationModalModule {}
